<script>
   export let header = "test";
   export let subheader = "longer text"
   export let text = ''
   export let i;
   
</script>
<div id='container' data-index={i}>
   
   <h1>
      {header}
   </h1>
   <h4>
      {subheader}
   </h4>
   <p>
      {@html text}
   </p>  
</div>

<style>
   #container {
      color:hsl(0, 0%, 4%);
      height: 100%;
      background-color: hsl(353, 10%, 90%, 0.7);
      padding: 0em 1em 0em 1em;
      transition: 0.5s;
   }
   [data-index="1"]#container {
      color:hsl(0, 0%, 96%);
      background-color: hsl(0, 50%, 30%, 0.7);
   }
   #container:hover {
      background-color: hsl(353, 10%, 90%, 0.85);
   }
   [data-index="1"]#container:hover {

      background-color: hsl(0, 50%, 30%, 0.85);
   }
   
</style>